const baseURL = '/emailAutomation';

async function getEmailAutomationSetting({ viewId }) {
    const res = await axios.get(`${baseURL}?viewId=${viewId}`);
    return res.data;
}

async function updateEmailAutomationSetting({
    viewId,
    name,
    emails,
    enabled,
    interval,
    hour,
    day,
    date,
    id: emailAutomationId,
}) {
    try {
        if (!viewId) {
            throw new Error('viewId does not exists');
        }
    } catch (e) {
        console.log(e);
    }

    let url = `${baseURL}`;

    if (emailAutomationId) url += `/${emailAutomationId}`;

    const data = {
        name,
        emails,
        enabled,
        interval,
        hour,
        day,
        date,
        viewId,
    };

    const res = await axios.put(url, data);
    return res.data;
}

export default {
    getEmailAutomationSetting,
    updateEmailAutomationSetting,
};
